import ExitGameCommand from "../../../../../shared/src/ranj/app/core/ExitGameCommand";
import PlatformAPIService from "../../../../../shared/src/ranj/equalture/platform/PlatformAPIService";
import Config from "../../../../../shared/src/ranj/app/config/Config";

export default class CollaborationExitGameCommand extends ExitGameCommand {
    /**    
     * @param {PlatformAPIService} platformAPIService 
     * @param {Config} config
     */
    constructor(platformAPIService, config) {
        super(platformAPIService);

        this._config = config;
    }

    execute() {
        // NB: ensure to set app id back to base ID before exiting
        const appId = this._config.getValue(Config.APPID);
        this._platformAPIService.setAppId(appId);

        super.execute();
    }
}